<template>
  <div class="flex m-4 shadow-xl rounded bg-black lg:static relative text-center lg:text-left">
    <img
      class="lg:w-6/12 h-auto object-cover mr-3 rounded-l"
      :src="year.backgroundImg"
      alt
    />    
    <div v-if="isDetailOpen" class="flex flex-col p-6">
      <h1 class="text-4xl font-bold mb-2 text-red-700">{{ year.title }}</h1>
      <ul class="list-outside">
        <li v-for="memory in year.memories" :key="memory"
            class="text-md mb-2 text-white"
        >{{ memory }}
        </li>
      </ul>
    </div>
    <div v-else class="absolute inset-y-0 right-0 m-8">
      <h1 class="text-6xl font-bold mb-2 text-red-700">
        {{ year.title }}
      </h1>
    </div>
  </div>
</template>
<script>
export default {
   data() {
    return {
      isDetailOpen: (window.innerWidth >= 1024)
    }
   },
   props: {
    year: {
      type: Object,
      required: true
    }
  },
  mounted() {
    window.addEventListener(
      'resize',
      this.openDetails
    )
  },
   methods: {
    openDetails(){
        this.isDetailOpen = (window.innerWidth >= 1024)
        console.log(this.isDetailOpen?'desktop':'mobile')
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/timeline/Year.vue